import {
  SurveyProgress,
  SurveyQuestion,
  SurveyQuestionAnswer,
} from '@chiroup/core/types/Survey.type';

// Shared type contract for every question component, the dispatcher,
// and any renderers override the caller might pass in. Keeping it in
// its own file means a new visual variation can import this without
// dragging the entire Soft Card primitives tree along.

export type SoftQuestionProps = {
  question: SurveyQuestion;
  progress: SurveyProgress | undefined;
  language: 'en' | 'es';
  primaryColor: string;
  disabled: boolean;
  hidden: boolean;
  showPrevious: boolean;
  onBack: () => void;
  onSelect: (val: SurveyQuestionAnswer) => Promise<void>;
};

export type SoftSurveyMeta = {
  title: string;
  subtitle?: string;
  startMessage?: string;
  endMessage?: string;
};

// One renderer per built-in question type. The dispatcher merges this
// over its defaults so callers can swap individual types without
// having to re-implement the rest. e.g.
//
//     <SoftSurveyQuestion {...props} renderers={{ slider: MyBigSlider }} />
//
// would use MyBigSlider but keep all the other types untouched.
export type SoftQuestionRenderers = {
  radio?: React.FC<SoftQuestionProps>;
  checkbox?: React.FC<SoftQuestionProps>;
  input?: React.FC<SoftQuestionProps>;
  textarea?: React.FC<SoftQuestionProps>;
  slider?: React.FC<SoftQuestionProps>;
  date?: React.FC<SoftQuestionProps>;
  group?: React.FC<SoftQuestionProps>;
};

// Verbiage shared across question types.
export const surveyVerbiage = {
  en: {
    next: 'Continue',
    noneOfTheAbove: 'None of the above',
    other: 'Other',
    otherPlaceholder: 'Please specify',
    previous: '← Previous',
  },
  es: {
    next: 'Continuar',
    noneOfTheAbove: 'Ninguna de las anteriores',
    other: 'Otro',
    otherPlaceholder: 'Por favor especifique',
    previous: '← Anterior',
  },
};
